import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import { Url } from '../../config/config'
import { isLoggedIn } from '../../utils'
import useButtonLoader from '../../hooks/useButtonLoader'
import { Instance, setToken } from '../../config/Instance'

export default function AddMarketingPartner() {

    //****************************** Handle all state for Form data *********************************//
    // State for getting state list form API
    const [stateList, setStateList] = useState([])
    const [cityList, setCityList] = useState([])

    // State for FormData
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        city: '',
        state: '',
        companyName: '',
    });

    // State for Showing Error for Form Data
    const [errorField, setErrorField] = useState({
        name: '',
        mobile: '',
        email: '',
        state: '',
        city: '',
        companyName: '',
    })


    //*************************** Destructuring Variables for handle Form Validation *********************//
    const {
        name,
        mobile,
        email,
        state,
        city,
        companyName,
    } = formData


    // ******************* Custom Hook for Submit button ***************************//
    const [submitButtonElement, setSubmitLoading] = useButtonLoader(
        'Submit',
        'Please wait...',
    )

    const navigate = useNavigate()


    //************************ Function for getting State list form API ****************************//
    const handelStateListing = async () => {
        try {
            const { data } = await Instance
                .get(`state`, setToken())
            if (data.status === 200) {
                setStateList(data.data.allState)
            } else {
                toast.error('Something went to wrong')
            }
        } catch (err) {
            console.log(err)
        }
    }

    //************************ Function for getting City list form API ****************************//
    const handleCityListing = async (stateId) => {
        try {
            const { data } = await Instance.get(`/city?stateId=${stateId}`)
            if (data.status === 200) {
                setCityList(data.data.cities || [])
            }
        } catch (err) {
            console.log(err)
        }
    }

    //************************ Handel OnChange ***************************** */
    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value, })
    }

    //************************ Handel State Change ***************************** */
    const handleStateChange = (e) => {
        const selectedIndex = e.target.selectedIndex
        const stateId = e.target.options[selectedIndex].dataset.id
        const stateName = e.target.value

        setFormData({ ...formData, state: stateName, city: '' })
        setCityList([])

        if (stateId) {
            handleCityListing(stateId)
        }
    }

    //*********************Handel Validation********************************** */
    const handleValidation = () => {
        let errorField = {}
        let formIsValid = true

        if (!name) {
            errorField['name'] = 'Please enter person full name'
            formIsValid = false
        }

        if (!mobile) {
            errorField['mobile'] = 'Please enter contact number'
            formIsValid = false
        }

        if (!state) {
            errorField['state'] = 'Please select state'
            formIsValid = false
        }

        if (!companyName) {
            errorField['companyName'] = 'Please enter company name'
            formIsValid = false
        }

        if (!email) {
            errorField['email'] = 'Please enter email address'
            formIsValid = false
        }

        if (!city) {
            errorField['city'] = 'Please select city'
            formIsValid = false
        }

        setErrorField(errorField)
        return formIsValid
    }


    //********************* Handle OnSubmit function for Submit Form data ************************************//
    const handelSubmit = async (e) => {
        e.preventDefault();
        try {
            if (handleValidation()) {
                setSubmitLoading(true)
                const { data } = await Instance
                    .post(`/marketing/add`, formData, setToken())
                if (data.status === 200) {
                    toast.success(data.message)
                    setSubmitLoading(false)
                    navigate('/marketing-partner')
                }
                else {
                    toast.error(data.message)
                    setSubmitLoading(false)
                }
            }
        } catch (err) {
            console.log(err)
        }
    }

    // useEffect it run only once at the time of getting details of State form API
    useEffect(() => {
        handelStateListing()
    }, [])



    //********************** Start HTML PART(JSX PART)  **********************************//
    return (
        <React.Fragment>
            <title>Add New Marketing Partner</title>
            <div className="WrapperArea _add_partner">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <h4 className="Title back_wrap">
                            {" "}
                            <Link to="/marketing-partner" className="back_btn">
                                <i className="fa fa-arrow-left"></i>
                            </Link>
                            Add New Marketing Partner
                        </h4>

                        <form method="POST" className='my-5'>
                            <div className="PasswordArea">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label> Full Name</label>
                                            <input
                                                type="text"
                                                value={name}
                                                onChange={handleInputChange}
                                                name="name"
                                                className="form-control"
                                                placeholder="Full name"
                                                maxLength="25"
                                                onKeyPress={(event) => {
                                                    if (!/[a-z A-Z]/.test(event.key)) {
                                                        event.preventDefault()
                                                    }
                                                }}
                                            />
                                            <span style={{ color: 'red' }} className="error">
                                                {errorField.name}
                                            </span>

                                        </div>
                                        <div className="form-group">
                                            <label>Phone Number</label>
                                            <input
                                                type="text"
                                                value={mobile}
                                                onChange={handleInputChange}
                                                name="mobile"
                                                className="form-control"
                                                placeholder="Phone Number"
                                                maxLength="10"
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault()
                                                    }
                                                }}
                                            />
                                            <span style={{ color: 'red' }} className="error">
                                                {errorField.mobile}
                                            </span>
                                        </div>

                                        <div className="form-group">
                                            <label>State</label>
                                            <select
                                                className="form-control"
                                                name="state"
                                                onChange={handleStateChange}
                                            >
                                                <option value="">Select State</option>
                                                {stateList &&
                                                    stateList.length > 0 &&
                                                    stateList.map((item, i) => (
                                                        <option key={i} value={item.state} data-id={item._id}>
                                                            {item.state}
                                                        </option>
                                                    ))}
                                            </select>
                                            <span style={{ color: 'red' }} className="error">
                                                {errorField.state}
                                            </span>
                                        </div>

                                    </div>

                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label>Company Name</label>
                                            <input
                                                type="text"
                                                value={companyName}
                                                onChange={handleInputChange}
                                                name="companyName"
                                                className="form-control"
                                                placeholder="Company Name"
                                            />
                                            <span style={{ color: 'red' }} className="error">
                                                {errorField.companyName}
                                            </span>
                                        </div>

                                        <div className="form-group">
                                            <label>Email</label>
                                            <input
                                                type="text"
                                                value={email}
                                                onChange={handleInputChange}
                                                name="email"
                                                className="form-control"
                                                placeholder="Email"
                                            />
                                            <span style={{ color: 'red' }} className="error">
                                                {errorField.email}
                                            </span>
                                        </div>

                                        <div className="form-group">
                                            <label>City</label>
                                            <select
                                                className="form-control"
                                                name="city"
                                                value={city}
                                                onChange={handleInputChange}
                                                disabled={!state}
                                            >
                                                <option value="">Select City</option>
                                                {cityList &&
                                                    cityList.map((item, i) => (
                                                        <option key={i} value={item.city}>
                                                            {item.city}
                                                        </option>
                                                    ))}
                                            </select>
                                            <span style={{ color: 'red' }} className="error">
                                                {errorField.city}
                                            </span>
                                        </div>

                                    </div>
                                    <div className='button_wrap'>
                                        <button
                                            className="button"
                                            onClick={handelSubmit}
                                            ref={submitButtonElement}
                                        >
                                            Submit
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
